import menuitems from "../menuitems";

export const getTitleAndContentLink = store =>
{
  let titleAndLink={
        link: store.clicks.link,
        title: store.clicks.title,
    };
  return titleAndLink;
}

export const getActiveButtons = store =>
{
  if(store.clicks.menuitem)
  {
    return {
      nav: menuitems.indexOf(store.clicks.menuitem),
      sub: store.clicks.submenuButton
    };
  }

  let buttons={
    nav: store.clicks.navButton,
    sub: store.clicks.submenuButton
  };
  return buttons;
}


// Depth-first search of the (nested) menu tree for the first item matching a predicate.
const findMenuItem = (items, predicate) => {
    if (!Array.isArray(items)) return undefined;
    for (const item of items) {
        if (predicate(item)) return item;
        if (item.submenu) {
            const found = findMenuItem(item.submenu, predicate);
            if (found) return found;
        }
    }
    return undefined;
};

export const getTitleContentLinkAndParameters = store => {
    // Section (eyebrow) = the active top-level menu group. Derive it from the active nav
    // index, which is tracked on BOTH navigation paths — the F5/link_click path and the
    // sidebar nav/submenu path. (store.clicks.menuitem is only set on the F5 path, so
    // reading it directly left the eyebrow blank after in-app navigation.)
    const navIndex = getActiveButtons(store).nav;
    const activeSection = typeof navIndex === 'number' ? menuitems[navIndex] : undefined;
    // A URL-only page can live in a hidden catch-all group (e.g. "Don't show up") whose
    // text is not a meaningful eyebrow. Let such an item declare an explicit `section`
    // override, which wins over the resolved group text. Only items that declare a
    // `section` are considered (matched by url, or by text since the F5/deep-link path
    // leaves clicks.url empty), so every other page is unaffected.
    // Match the active menu item on either nav path: in-app nav sets clicks.url, while the
    // F5/deep-link path (content.js) sets clicks.title but leaves clicks.url empty.
    const matchesClick = (item) =>
        (store.clicks.url && item.url === store.clicks.url) ||
        (store.clicks.title && item.text === store.clicks.title);
    const activeItem = findMenuItem(menuitems, (item) => item.section && matchesClick(item));
    // Report pages all live in the hidden "Don't show up" bucket but share a `reports_` url
    // prefix; their eyebrow should read "Reports" without each entry declaring a section.
    const reportItem = activeItem
        ? undefined
        : findMenuItem(menuitems, (item) => item.url && item.url.indexOf('reports_') === 0 && matchesClick(item));
    let titleAndLink = {
        link: store.clicks.link,
        title: store.clicks.title,
        icon:store.clicks.icon,
        url: store.clicks.url,
        section: (activeItem && activeItem.section)
            ? activeItem.section
            : reportItem
                ? 'Reports'
                : (activeSection ? activeSection.text : undefined),
    };
    return titleAndLink;
}

